/**
 * Canonical Community Operating System family copy and outbound URLs.
 * Ourware is the organization that supports community operating systems.
 */

export const OURWARE_NAME = "Ourware" as const;
export const OURWARE_URL = "https://ourware.org" as const;

export const OURWARE_SOCIALS = [
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61593821631787",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/143378951",
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/channel/UC85lDAayTYjkqPFOyDaORWA",
  },
  { id: "x", label: "X", href: "https://x.com/ourware" },
] as const;

export const SCOOLING_NAME = "scool.ing" as const;
export const SCOOLING_URL = "https://scool.ing" as const;

export const MUSEHUB_NAME = "MuseHub" as const;
export const MUSEHUB_URL = "https://musehub.ai/" as const;

export const KNOWTATION_NAME = "Knowtation" as const;
export const KNOWTATION_URL = "https://knowtation.store/" as const;

/** Forbidden misspellings / wrong hosts for the lifelong-learning sister. */
export const FORBIDDEN_SCOOLING_LABELS = ["school.ing", "schooling"] as const;
export const FORBIDDEN_SCOOLING_HOSTS = [
  "https://school.ing",
  "http://school.ing",
  "https://www.school.ing",
] as const;

export const OURWARE_ENTRANCE =
  "BornFree is part of Ourware, the organization that supports the development of community operating systems. We aspire to treat everybody as if you were their parent. People, teams, and organizations of every size deserve tools of equal seriousness to the ones large institutions already use: owned memory, reviewable proposals, private learning, and shared place. Shared intelligence for life, work, and play — private by default, reviewable by choice." as const;

export const OURWARE_ROLE =
  "Supports the development of community operating systems" as const;

/** Brief Why teaser — visible without scrolling to the dedicated section. */
export const OURWARE_TEASER =
  "BornFree is part of Ourware, the organization that supports the development of community operating systems." as const;

export const OURWARE_FOOTER_KICKER = "A Family Member of" as const;

export const SCOOLING_ROLE = "Open source lifelong learning" as const;
export const SCOOLING_SUMMARY =
  "Private-by-default learning that connects school, work, research, and teams—with vault-first memory, custom models, and human collaboration built in from the start." as const;

export const MUSEHUB_ROLE = "Open source graph & version control" as const;
export const MUSEHUB_SUMMARY =
  "Versioned knowledge surfaces patterns across symbols, differences, time, prediction, and causal effects—where agents and humans collaborate as equals." as const;

export const KNOWTATION_ROLE = "Open source vault source of truth" as const;
export const KNOWTATION_SUMMARY =
  "Own your notes, documents, memory layers, and discovery paths in a vault-first knowledge system—with human-in-the-loop proposals and agent-ready search." as const;

export const FAMILY_OUTBOUND = [
  { name: OURWARE_NAME, url: OURWARE_URL },
  { name: SCOOLING_NAME, url: SCOOLING_URL },
  { name: MUSEHUB_NAME, url: MUSEHUB_URL },
  { name: KNOWTATION_NAME, url: KNOWTATION_URL },
] as const;

export function isForbiddenScoolingUrl(href: string): boolean {
  const normalized = href.trim().toLowerCase();
  return FORBIDDEN_SCOOLING_HOSTS.some((bad) => normalized.startsWith(bad));
}

export function assertSafeOutboundHref(href: string): void {
  if (!href.startsWith("https://")) {
    throw new Error(`Outbound family URL must use https: ${href}`);
  }
  if (isForbiddenScoolingUrl(href)) {
    throw new Error(`Forbidden school.ing host: ${href}`);
  }
}

export function copyAvoidsParentHere(text: string): boolean {
  return !/parent here/i.test(text) && !/parent company/i.test(text);
}
